import React from 'react';

export interface AppSettingsModalContextValue {
  onClose: () => void;
  onFormDirtyChange: (dirty: boolean) => void;
  /** Register a save function. Return `false` to prevent auto-close after save. */
  registerSave: (saveFn: () => Promise<boolean | void>) => void;
}

export const AppSettingsModalContext =
  React.createContext<AppSettingsModalContextValue | null>(null);
